<template>
  <div v-if='loading'>
    <OilForm
      :title='title'
      :items='SupplierConsignmentModel'
      :keys='itemKey'
      :createForm='!id'
      :formCallback='formCallBack'
      @PartyInformationTotalAmountInTons='changeTotalAmountInTons'
      @PartyInformationPricePerTonnes='changePricePerTonnes'
      @PartyInformationExcise='changeExcise'
      @PartyInformationVAT='changeVAT'
    >

      <template v-slot:Supplier.Id='{input}'>
        <v-select
          :items='suppliers'
          label='Выбрать поставщика'
          v-model='SupplierConsignmentModel.Supplier'
          item-text='Name'
          item-value='Id'
          :disabled='!input.isEdit'
          outlined
          dense
          return-object
        />
      </template>
      <template v-slot:Waybill.Id='{input}'>
        <v-select
          :items='waybills'
          label='Выбрать ТТН'
          v-model='SupplierConsignmentModel.Waybill'
          item-value='Id'
          item-text='Number'
          :disabled='!input.isEdit'
          outlined
          dense
          return-object
        />
      </template>
      <template v-slot:Empowerment.Id='{input}'>
        <v-select
          :items='empowerments'
          label='Выбрать доверенность'
          v-model='SupplierConsignmentModel.Empowerment'
          item-value='Id'
          item-text='Number'
          :disabled='!input.isEdit'
          outlined
          dense
          return-object
        />
      </template>
      <template v-slot:Terminal.Id='{input}'>
        <v-select
          :items='terminals'
          label='Выбрать базу'
          v-model='SupplierConsignmentModel.Terminal'
          @change='changeTerminal'
          item-value='Id'
          item-text='Name'
          :disabled='!input.isEdit'
          outlined
          dense
          return-object
        />
      </template>
      <template v-slot:Product.Id='{input}'>
        <v-select
          :items='products'
          label='Выбрать товар'
          v-model='SupplierConsignmentModel.Product'
          item-value='Id'
          item-text='Name'
          :disabled='!input.isEdit'
          outlined
          dense
          return-object
        />
      </template>


      <template v-slot:Registry='{input}' v-if='id'>
        <OilRegistry :call='calculate' :disabled='input.isEdit'
                     :items='SupplierConsignmentModel.OtherExpenses' />
      </template>
      <template v-slot:Information=''>
        <h4>Информация о партии</h4>
      </template>
      <template v-slot:Expense=''>
        <h4>РАСХОДЫ</h4>
      </template>
      <template v-slot:Calculation=''>
        <h4>РАСЧЕТЫ</h4>
      </template>
      <template v-slot:Consumption=''>
        <h4>ИТОГО РАСХОД</h4>
      </template>
      <template v-slot:Calculate='{input}'>
        <v-btn color='primary' @click='count' :disabled='!input.isEdit'>РАСЧИТАТЬ</v-btn>
      </template>
      <template v-slot:Cost=''>
        <h4>Себестоимость товар</h4>
      </template>
    </OilForm>
  </div>
</template>
<script>
import itemKey from './setting/consignment_supply.json'
import { coreApi } from '~/services/core'
import { consignmentSupplyService } from '@/services/ConsignmentSupplyService'
import { consignmentImporterService } from '~/services/ConsignmentImporterService'
import { num2str } from '~/utils/functions/MoneyFromString'

export default {
  props: {
    id: String
  },
  components: {
    OilForm: () => import('@/components/helper/oil.form'),
    OilRegistry: () => import('@/pages/consignment_supply/setting/registry')
  },
  data() {
    return {
      select_item: [],
      title: 'ПРИХОД',
      SupplierConsignmentModel: {
        PartyInformation: {},
        Expenses: {},
        OtherExpenses: [],
        Amount: 0
      },
      itemKey: itemKey,
      suppliers: [],
      waybills: [],
      empowerments: [],
      terminals: [],
      products: [],

      expens: 0,
      otherExpens: 0,

      loading: false
    }
  },
  async created() {
    const suppliers = await coreApi.get('suppler')
    this.suppliers = suppliers.data || []

    const waybills = await coreApi.get('coming-waybill')
    this.waybills = waybills.data || []

    const empowerment = await coreApi.get('coming-empowerment')
    this.empowerments = empowerment.data || []

    const terminal = await coreApi.get('terminal')
    this.terminals = terminal.data || []


    if (this.id) {
      const consignment = await consignmentSupplyService.getById(this.id)
      this.SupplierConsignmentModel = consignment.data || []
      this.changeTerminal(this.SupplierConsignmentModel.Terminal)
      this.changeVAT(this.SupplierConsignmentModel.PartyInformation.VAT)
    }


    this.loading = true
  },
  computed: {
    storeType() {
      return this.id ? coreApi.put : coreApi.post
    },
    message() {
      return this.id ? 'партия удачно изменен' : 'партия удачно создан'
    }
  },
  methods: {
    async formCallBack(data, input,form,func) {
      input.isEdit = false
      const response = await this.storeType('supplier-consignment', data)
      if (!response.data) {
        input.isEdit = true
        return
      }

      func(this.message)

      this.SupplierConsignmentModel = response.data

      this.$router.push('/consignments-supply')
    },
    changeTerminal(terminal) {
      if (terminal) {
        this.products = terminal.Products || []
        this.SupplierConsignmentModel.Terminal = { ...terminal }
      }
    },
    changeTotalAmountInTons(ton) {
      const SuCoPa = this.SupplierConsignmentModel.PartyInformation
      SuCoPa.Total = SuCoPa.PricePerTonnes * ton

      this.changeExcise(SuCoPa.Excise)
      this.changeVAT(SuCoPa.VAT)

    },
    changePricePerTonnes(sum) {
      const SuCoPa = this.SupplierConsignmentModel.PartyInformation
      SuCoPa.Total = SuCoPa.TotalAmountInTons * sum

      this.changeExcise(SuCoPa.Excise)
      this.changeVAT(SuCoPa.VAT)
    },
    changeExcise(num) {
      const SuCoPa = this.SupplierConsignmentModel.PartyInformation
      SuCoPa.TotalExcise = SuCoPa.Total * num / 100

      this.changeVAT(SuCoPa.VAT)
    },
    changeVAT(vat) {
      const SuCoPa = this.SupplierConsignmentModel.PartyInformation
      SuCoPa.RateVAT =
        (SuCoPa.Total +
          SuCoPa.TotalExcise) * vat / 100
    },


    count() {

      this.calculate(this.SupplierConsignmentModel.OtherExpenses)

      this.SupplierConsignmentModel.Amount =
        this.otherExpens + this.expens +
        this.SupplierConsignmentModel.PartyInformation.Total +
        this.SupplierConsignmentModel.PartyInformation.TotalExcise

      this.SupplierConsignmentModel.PricePerTonInSoums =
        this.SupplierConsignmentModel.Amount / this.SupplierConsignmentModel.PartyInformation.TotalAmountInTons

      this.SupplierConsignmentModel.TotalConsignment =
        this.SupplierConsignmentModel.Amount +
        this.SupplierConsignmentModel.PartyInformation.RateVAT

    },

    calculation() {
      const expenses = this.SupplierConsignmentModel.Expenses
      const keys = Object.keys(expenses)
      let sum1 = 0
      keys.forEach(k => {
        sum1 += parseFloat(expenses[k])
      })
      this.expens = sum1
    },
    /**
     * @param {array} registry
     */
    calculate(registry) {
      let sum = 0
      registry.forEach(({ Expenses1, Expenses2 }) => {
        sum += parseFloat(Expenses1) + parseFloat(Expenses2)
      })
      this.otherExpens = sum
    }
  },
  watch: {
    'SupplierConsignmentModel.Expenses': {
      deep: true,
      handler() {
        this.calculation()
      }
    },
    'SupplierConsignmentModel.TotalConsignment'(price) {
      this.SupplierConsignmentModel.AmountCum = num2str(price)
    }
  }
}
</script>

<style scoped>

</style>